import React, { useEffect, useState } from 'react';
import { Form, Input, DatePicker, Upload, Button, Card, Select, Table, message, Spin, Popconfirm } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Row, Col } from 'react-bootstrap'
import axios from 'axios';
import { SERVER_URL } from '../../../const';
import { getAllAdminIECsService } from '../../../services/FileDataService'
import BondEditModal from './BondEditModal'

const { TextArea } = Input;
const { Option } = Select;

const iec_no = localStorage.getItem('iec_no')

const edit = ` <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
</svg>`;

const deleteIcon = ` <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
<path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
</svg>`;

const BondFormComponent = () => {
  const [bondTypes, setBondTypes] = useState([]);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [userRole, setUserRole] = useState(localStorage.getItem('role'))
  const [IECOptions, setIECOptions] = useState([]);
  const [selectedIEC, setSelectedIEC] = useState(
    (localStorage.getItem('role') === 'superadmin' || localStorage.getItem('role') === 'group_head')
      ? null
      : localStorage.getItem('iec_no')
  );
  const [iecName, setIECName] = useState(
    (localStorage.getItem('role') === 'superadmin' || localStorage.getItem('role') === 'group_head')
      ? ''
      : localStorage.getItem('name')
  );

  useEffect(() => {
    // Fetch bond types from the backend API
    fetchBondData();
    fetchBondTypes();
    getAdminIEC();
  }, []);

  const handleIECSelection = (val) => {
    console.log(val)
    if (val){
      let iec_no = val.split(";")[0];
      let iec_name = val.split(";")[1];
      setSelectedIEC(iec_no)
      setIECName(iec_name)
    }
    else{
      setSelectedIEC(null);
      setIECName('');
    }
  }

  const getAdminIEC = async () => {
    const token = localStorage.getItem('token');
    const response = await getAllAdminIECsService(token);

    if (response && response.data){
      let i = 0;
      const options = response.data.map(item => ({
        value: `${item.iec_no};${item.fullname}`,
        label: `${item.iec_no} (${item.fullname})`,
        key: i++,
      }));

      setIECOptions(options);
    }
    
  }

  const fetchBondData = async () => {
    const token = localStorage.getItem('token');
    try {
      setLoading(true);
      let get_iec = iec_no;
      if (userRole == 'superadmin' || userRole == 'group_head'){
        get_iec = 'all'
      }
      const response = await axios.get(`${SERVER_URL}/get-bond-forms?iec_no=${get_iec}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      // Set the parsed data
      setData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      message.error('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const deleteBondDetailsService = async (id, token) => {
    try {
      setLoading(true);
      const response = await axios.delete(`${SERVER_URL}/bond-details/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

    } catch (error) {
      console.error('Error delete data:', error);
      message.error('Failed to delete data');
    } finally {
      setLoading(false);
    }
  }

  const cancel = (e) => {
    console.log(e);
  };

  const deleteBondCertificate = async (record) => {
    console.log("delete record: ", record);
      const id = record.signal_bond_details_id;
      // Append any additional data or files if needed
      const token = localStorage.getItem('token');
      try{
        const response = await deleteBondDetailsService(id, token);
        fetchBondData();
        message.success('Deleted successfully');
      }
      catch(error){
        console.log(error);
        message.error("Error")
      }
  }
  const handleShow = () => setShowModal(true);

  const editBondCertificate = (record) => {
    setEditData(record);
    handleShow();
  }

  const handleClose = (event) => {
    fetchBondData();
    setShowModal(false);
    if (event === 'update') {
      message.success('Updated successfully');
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "iconAction",
      width: 80,
      fixed: 'left',
      render: (text, record) => {
        return (
          <div class="flex align-items-center list-user-action">
            <a onClick={() => editBondCertificate(record)} class="btn btn-sm btn-icon btn-warning" data-toggle="tooltip" data-placement="top" title="" data-original-title="Add" to="#">
              <span class="btn-inner" dangerouslySetInnerHTML={{ __html: edit}}>
                
              </span>
            </a>
            &nbsp;
            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              onConfirm={() => deleteBondCertificate(record)}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <a class="btn btn-sm btn-icon btn-danger" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete" to="#">
                <span class="btn-inner" dangerouslySetInnerHTML={{ __html: deleteIcon}}>
                  
                </span>
              </a>
            </Popconfirm>
          </div>
        );
      },
    },
    {
      title: 'IEC',
      dataIndex: 'iec_no',
      key: 'iec_no',
      width: 120,
    },
    {
      title: 'IEC Name',
      dataIndex: 'fullname',
      key: 'fullname',
      width: 250,
    },
    {
      title: 'Bond Type',
      dataIndex: 'bond_type',
      key: 'bond_type',
      width: 150,
    },
    {
      title: 'Bond No',
      dataIndex: 'bond_no',
      key: 'bond_no',
      width: 150,
    },
    {
      title: 'BG No',
      dataIndex: 'bg_no',
      key: 'bg_no',
      width: 150,
    },
    {
      title: 'Bond Name',
      dataIndex: 'bond_name',
      key: 'bond_name',
      width: 200,
    },
    {
      title: 'Bond Date',
      dataIndex: 'date',
      key: 'date',
      width: 120,
    },
    {
      title: 'Submitted To',
      dataIndex: 'submitted_to',
      key: 'submitted_to',
      width: 180,
    },
    {
      title: 'File No',
      dataIndex: 'file_no',
      key: 'file_no',
      width: 150,
    },
    {
      title: 'Accepted Date',
      dataIndex: 'accepted_date',
      key: 'accepted_date',
      width: 130,
    },
    {
      title: 'BG/Bond Value',
      dataIndex: 'bond_value',
      key: 'bond_value',
      width: 150,
    },
    {
      title: 'BG Value',
      dataIndex: 'bg_value',
      key: 'bg_value',
      width: 150,
    },
    {
      title: 'Expiry Date',
      dataIndex: 'expiry_date',
      key: 'expiry_date',
      width: 130,
    },
    {
      title: 'Obligation Base',
      dataIndex: 'obligation_base',
      key: 'obligation_base',
      width: 250,
    },
  ];

  const fetchBondTypes = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${SERVER_URL}/get-bond-types`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setBondTypes(JSON.parse(response.data));
    } catch (error) {
      console.error('Error fetching bond types:', error);
    }
  };

  const onFinish = async (values) => {
    setLoader(true);
    const token = localStorage.getItem('token');
    
    // Sanitize optional/empty values for backend compatibility
    const sanitizedValues = { ...values };
    
    // Convert DatePicker values to appropriate format or null
    sanitizedValues.accepted_date = values.accepted_date ? values.accepted_date.format('YYYY-MM-DD') : null;
    sanitizedValues.expiry_date = values.expiry_date ? values.expiry_date.format('YYYY-MM-DD') : null;
    sanitizedValues.date = values.date ? values.date.format('YYYY-MM-DD') : null;
    sanitizedValues.iec_no = selectedIEC;

    // Convert other empty/undefined values to null
    const optionalFields = ['submitted_to', 'bond_value', 'bg_value', 'bg_no', 'obligation_base', 'file_no'];
    optionalFields.forEach(field => {
      if (sanitizedValues[field] === undefined || sanitizedValues[field] === '' || sanitizedValues[field] === null) {
        sanitizedValues[field] = null;
      } else if (field === 'bond_value' || field === 'bg_value') {
        const parsed = parseFloat(sanitizedValues[field]);
        sanitizedValues[field] = isNaN(parsed) ? null : parsed;
      }
    });

    // Add bond_type_id to values
    const selectedBondType = bondTypes.find(bondType => bondType.bond_type_code === values.bond_type);
    sanitizedValues.bond_type_id = selectedBondType ? Number(selectedBondType.bond_type_id) : null;

    try {
      const response = await axios.post(`${SERVER_URL}/submit-bond-form`, sanitizedValues, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      fetchBondData();
      form.resetFields();
      setLoader(false);
      //message.success(response.data.message);
    } catch (error) {
      setLoader(false);
      console.error('Error submitting form:', error);
      //message.error('Form submission failed');
    }
  };

  return (
    <div>
      <Card title="Bond">
        <Spin spinning={loader}>

        {userRole && (userRole == 'superadmin' || userRole == 'group_head') &&
        <Form form={form} name="bond_report" onFinish={onFinish}>
          <Row>
            <Col lg="6" md="6">
            <Form.Item label="Select IEC " name="select_iec">

              <Select
                  focus
                  showSearch
                  placeholder="Select IEC"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={handleIECSelection}
                  allowClear
                  options={IECOptions}
                  style={{ width: '300px' }}
                />   
              
            </Form.Item>
            
            </Col>
            <Col lg="6" md="6">
            <h6 style={{display: 'inline-block', textAlign: 'center'}}><b>{iecName}</b></h6>
              &nbsp;&nbsp;&nbsp;
              <strong>{selectedIEC}</strong>
            </Col>
          </Row>
          <Row>
            <Col lg="6" md="6">
              <Form.Item label="Type of Bond" name="bond_type" rules={[{ required: true }]}>
              <Select>
                {bondTypes.map(bondType => (
                  <Option key={bondType.bond_type_id} value={bondType.bond_type_code}>
                    {bondType.bond_type_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            </Col>
            <Col lg="6" md="6">
              <Form.Item label="Name" name="bond_name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            </Col>
          </Row>
          
          <Row>
            <Col lg="6" md="6">
              <Form.Item label="Bond Date" name="date" rules={[{ required: true }]}>
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col lg="6" md="6">
              <Form.Item label="Submitted to" name="submitted_to">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg="6" md="6">
              <Form.Item label="Bond No." name="bond_no" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col lg="6" md="6">
              <Form.Item label="Bond Value" name="bond_value">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg="6" md="6">
              <Form.Item label="BG No." name="bg_no">
                <Input />
              </Form.Item>
            </Col>
            <Col lg="6" md="6">
              <Form.Item label="BG Value" name="bg_value">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg="6" md="6">
              <Form.Item label="Accepted Date" name="accepted_date">
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg="6" md="6">
              <Form.Item label="File No." name="file_no">
                <Input />
              </Form.Item>
            </Col>
            <Col lg="6" md="6">
              <Form.Item label="Date of Expiry" name="expiry_date">
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
           
          </Row>
          <Row>
            <Col lg="12" md="12">
              <Form.Item label="Obligation Base" name="obligation_base">
                <TextArea rows={4} />
              </Form.Item>
            </Col>
            
          </Row>
          
          
          {/* <Form.Item label="Upload Copy" name="upload_copy">
            <Upload>
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item> */}
          <Form.Item>
            <Button type="primary" htmlType="submit" className="cip-action-btn">Submit</Button>
          </Form.Item>
        </Form>
        }
        </Spin>
        
        
      </Card>
      <BondEditModal title={"BOND"} handleClose={handleClose} open={showModal} data={editData} dropdownData={{bondTypes:bondTypes}}/>
      <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey={(record) => record.id} // Assuming each record has a unique 'id'
            scroll={{ x: 'max-content' }}
          />
        </div>
        <br/>
        <br/>
    </div>
  );
};

export default BondFormComponent;
